import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { IApplicationState } from "../../store/models/IApplicationState";
import { IState } from "../../store/models/IState";
import MessageAlert, { MessageAlertType } from "../common/MessageAlert";

export interface IApplicationErrorProps {

}

/**
 * Error message that have been dispatched to the application state in redux will be displayed by this component
 * as an error message alert.
 * @param props 
 */
const ApplicationError: React.FC<IApplicationErrorProps> = (props): JSX.Element => {
    const applicationState: IApplicationState = useSelector((state: IState) => state.applicationState);
    const errorMessage = applicationState?.errorMessage

    function displayErrorAlert(): JSX.Element | null {
        if (errorMessage.length === 0) {
            return null;
        }

        return (
            <MessageAlert message={errorMessage || ""} type={MessageAlertType.Error} />
        )
    }

    return (
        <Fragment>
            {displayErrorAlert()}
        </Fragment>
    )
}

export default ApplicationError;